/**
 * ITalentSpellMode interface.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file ITalentSpellMode.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @interface
 */
export enum ITalentSpellMode {
  INIT        = 0,
  CONJURING   = 1,
  CASTING     = 2,
  CATCHING    = 3
};